module.exports = __webpack_public_path__ + "static/media/logoParavel.7fa95b33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/logoParavel.svg
// module id = 55
// module chunks = 0